import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const sports = ['Baseball','Basketball','Field Hockey','Football','Ice Hockey','Soccer','Softball','Volleyball'];
const sportIcons = { Baseball:'⚾', Basketball:'🏀', 'Field Hockey':'🏑', Football:'🏈', 'Ice Hockey':'🏒', Soccer:'⚽', Softball:'🥎', Volleyball:'🏐' };

const trophies = [
  { id:'patches_1',  title:'First Patch',      desc:'Scan your first patch',          color:'#CD7F32', threshold:'1 patch' },
  { id:'patches_5',  title:'Patch Collector',   desc:'Collect 5 patches',             color:'#C0C0C0', threshold:'5 patches' },
  { id:'patches_10', title:'Patch Hunter',      desc:'Collect 10 patches',            color:'#FFCC00', threshold:'10 patches' },
  { id:'patches_25', title:'Patch Enthusiast',  desc:'Collect 25 patches',            color:'#1A6EDB', threshold:'25 patches' },
  { id:'patches_50', title:'Patch Champion',    desc:'Collect 50 patches',            color:'#9C27B0', threshold:'50 patches' },
  { id:'patches_100',title:'Patch Legend',      desc:'Collect 100 patches',           color:'#E91E63', threshold:'100 patches' },
  { id:'states_5',   title:'Road Warrior',      desc:'Play in 5 different states',    color:'#CD7F32', threshold:'5 states' },
  { id:'states_10',  title:'State Hopper',      desc:'Play in 10 different states',   color:'#C0C0C0', threshold:'10 states' },
  { id:'states_20',  title:'Cross Country',     desc:'Play in 20 different states',   color:'#FFCC00', threshold:'20 states' },
  { id:'states_50',  title:'All 50 States',     desc:'Play in all 50 states!',        color:'#E91E63', threshold:'50 states' },
];

const steps = [
  { n:'01', icon:'🔍', title:'Find a Team', desc:'Compete against teams at tournaments and events across the country.' },
  { n:'02', icon:'📱', title:'Scan the QR Code', desc:'After the game, scan the team\'s patch QR code with the TPG app.' },
  { n:'03', icon:'📍', title:'Pin Them on Your Map', desc:'The team appears on your personal patch map — a living record of your journey.' },
  { n:'04', icon:'🏆', title:'Earn Trophies', desc:'Hit milestones for patches collected and states visited to unlock trophies.' },
];

export default function Home() {
  return (
    <div className="home">
      {/* ── HERO ─────────────────────────────────── */}
      <section className="hero">
        <div className="hero__bg">
          <div className="hero__grid" />
          <div className="hero__glow hero__glow--gold" />
          <div className="hero__glow hero__glow--blue" />
        </div>
        <div className="container hero__inner">
          <div className="hero__content animate-fade-up">
            <div className="badge badge-gold hero__badge">Now Available on iOS & Android</div>
            <h1 className="hero__title">
              Collect Patches.<br />
              <span className="hero__title-accent">Build Your Legacy.</span>
            </h1>
            <p className="hero__subtitle">
              The Patch Guys is the ultimate patch tracking app for youth sports.
              Scan QR codes, pin teams on your map, and earn trophies as you
              compete across the country.
            </p>
            <div className="hero__actions">
              <a href="https://apps.apple.com/app/id6760299209" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
                App Store
              </a>
              <a href="https://play.google.com" target="_blank" rel="noopener noreferrer" className="btn btn-blue btn-lg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M3.18 23.76c.3.17.64.24.99.2l12.47-7.2-2.75-2.76-10.71 9.76zM20.7 10.06L17.6 8.28 14.54 11.3l3.1 3.1 3.07-1.79a1.79 1.79 0 0 0 0-2.55zM2.08.47A1.79 1.79 0 0 0 1.5 1.83v20.34c0 .54.22 1.02.58 1.36l.07.07L13.72 12 2.15.4l-.07.07zM3.18.24l10.71 9.76 2.75-2.76L4.17.04a1.3 1.3 0 0 0-.99.2z"/></svg>
                Google Play
              </a>
              <Link to="/how-it-works" className="btn btn-outline-white btn-lg">
                How It Works
              </Link>
            </div>
            <div className="hero__stats">
              <div className="hero__stat">
                <span className="hero__stat-number">8</span>
                <span className="hero__stat-label">Sports</span>
              </div>
              <div className="hero__stat-divider" />
              <div className="hero__stat">
                <span className="hero__stat-number">12</span>
                <span className="hero__stat-label">Trophies</span>
              </div>
              <div className="hero__stat-divider" />
              <div className="hero__stat">
                <span className="hero__stat-number">50</span>
                <span className="hero__stat-label">States</span>
              </div>
            </div>
          </div>

          <div className="hero__visual animate-fade-up delay-2">
            <div className="hero__phone">
              <div className="hero__phone-screen">
                <div className="hero__map-mock">
                  <div className="hero__map-bg" />
                  <div className="hero__pin hero__pin--gold" style={{top:'35%',left:'45%'}}>
                    <span>⚽</span>
                  </div>
                  <div className="hero__pin hero__pin--gold" style={{top:'55%',left:'28%'}}>
                    <span>🏑</span>
                  </div>
                  <div className="hero__pin hero__pin--gold" style={{top:'40%',left:'65%'}}>
                    <span>⚾</span>
                  </div>
                  <div className="hero__pin hero__pin--purple" style={{top:'60%',left:'55%'}}>
                    <span>🏆</span>
                  </div>
                  <div className="hero__map-label">My Patch Map</div>
                </div>
                <div className="hero__phone-bar">
                  <div className="hero__phone-btn hero__phone-btn--teams">🏆 Teams <span>5</span></div>
                  <div className="hero__phone-btn hero__phone-btn--scan">⬡</div>
                  <div className="hero__phone-btn hero__phone-btn--events">🎫 Events <span>2</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── SPORTS STRIP ─────────────────────────── */}
      <section className="sports-strip">
        <div className="sports-strip__track">
          {[...sports, ...sports].map((s, i) => (
            <div key={i} className="sports-strip__item">
              <span className="sports-strip__icon">{sportIcons[s]}</span>
              <span className="sports-strip__name">{s}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── HOW IT WORKS PREVIEW ─────────────────── */}
      <section className="section how-preview">
        <div className="container">
          <div className="how-preview__header">
            <div className="tag-line">Simple by Design</div>
            <h2 className="section-title">How It Works</h2>
            <p className="section-subtitle">
              Four easy steps to start building your patch collection and tracking your sports journey.
            </p>
          </div>
          <div className="how-preview__steps">
            {steps.map((s, i) => (
              <div key={i} className={`how-step animate-fade-up delay-${i+1}`}>
                <div className="how-step__number">{s.n}</div>
                <div className="how-step__icon">{s.icon}</div>
                <h3 className="how-step__title">{s.title}</h3>
                <p className="how-step__desc">{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="how-preview__cta">
            <Link to="/how-it-works" className="btn btn-blue">
              Learn More →
            </Link>
          </div>
        </div>
      </section>

      {/* ── MAP FEATURE ──────────────────────────── */}
      <section className="section map-feature">
        <div className="container map-feature__inner">
          <div className="map-feature__visual">
            <div className="map-feature__mock">
              <div className="map-feature__mock-header">
                <div className="map-feature__mock-title">🗺 My Patch Map</div>
                <div className="map-feature__mock-kid">Madelynn ▾</div>
              </div>
              <div className="map-feature__map-bg">
                <div className="map-feature__pin" style={{top:'30%',left:'40%',background:'#FFCC00'}}>⚽</div>
                <div className="map-feature__pin" style={{top:'50%',left:'22%',background:'#FFCC00'}}>🏑</div>
                <div className="map-feature__pin" style={{top:'38%',left:'60%',background:'#FFCC00'}}>⚾</div>
                <div className="map-feature__pin" style={{top:'62%',left:'48%',background:'#9C27B0'}}>🏆</div>
                <div className="map-feature__pin" style={{top:'25%',left:'70%',background:'#FFCC00'}}>🏀</div>
                <div className="map-feature__pin" style={{top:'70%',left:'30%',background:'#FFCC00'}}>🏈</div>
              </div>
              <div className="map-feature__card">
                <div className="map-feature__card-logo">⚽</div>
                <div>
                  <div className="map-feature__card-name">Orlando FC</div>
                  <div className="map-feature__card-loc">📍 Orlando, FL</div>
                </div>
                <div className="map-feature__card-badge">×3</div>
              </div>
            </div>
          </div>
          <div className="map-feature__content">
            <div className="tag-line">Your Journey, Visualized</div>
            <h2 className="section-title">Every Team.<br/>On Your Map.</h2>
            <p className="section-subtitle">
              Watch your patch map grow as you compete across the country. Gold pins
              for teams, purple pins for events — each one a story from your athletic journey.
            </p>
            <ul className="map-feature__list">
              <li><span className="map-feature__check">✓</span> Interactive Google Maps with custom dark style</li>
              <li><span className="map-feature__check">✓</span> Team logos appear directly on the map</li>
              <li><span className="map-feature__check">✓</span> View team records, game history &amp; scores</li>
              <li><span className="map-feature__check">✓</span> Multiple kids, each with their own map</li>
              <li><span className="map-feature__check">✓</span> Track events alongside team patches</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ── TROPHIES ─────────────────────────────── */}
      <section className="section trophy-section">
        <div className="container">
          <div className="trophy-section__header">
            <div className="tag-line">Gamified Progress</div>
            <h2 className="section-title">Earn Trophies</h2>
            <p className="section-subtitle">
              Hit milestones to unlock trophies. 12 achievements across patch collection
              and states visited — complete with a confetti celebration!
            </p>
          </div>
          <div className="trophy-grid">
            {trophies.map(t => (
              <div key={t.id} className="trophy-card">
                <div className="trophy-card__icon" style={{ color: t.color }}>🏆</div>
                <div className="trophy-card__title">{t.title}</div>
                <div className="trophy-card__threshold" style={{ background: `${t.color}20`, color: t.color, border: `1px solid ${t.color}40` }}>
                  {t.threshold}
                </div>
                <div className="trophy-card__desc">{t.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── REGISTER CTA ─────────────────────────── */}
      <section className="reg-cta">
        <div className="container reg-cta__inner">
          <div className="reg-cta__content">
            <div className="tag-line" style={{color:'rgba(255,204,0,0.7)'}}>Get Your QR Code</div>
            <h2 className="section-title" style={{color:'white'}}>
              Register Your Team<br/>or Event
            </h2>
            <p style={{color:'rgba(255,255,255,0.7)', fontSize:'18px', lineHeight:'1.7', maxWidth:'480px'}}>
              Join the platform and get a unique QR code that players can scan at games
              and events. Free to register — just submit for approval.
            </p>
          </div>
          <div className="reg-cta__cards">
            <Link to="/register?type=team" className="reg-cta__card reg-cta__card--team">
              <div className="reg-cta__card-icon">🛡️</div>
              <h3>Register a Team</h3>
              <p>For sports clubs and traveling teams</p>
              <span className="btn btn-primary" style={{marginTop:'16px'}}>Get Started →</span>
            </Link>
            <Link to="/register?type=event" className="reg-cta__card reg-cta__card--event">
              <div className="reg-cta__card-icon">🎫</div>
              <h3>Register an Event</h3>
              <p>For tournaments and showcases</p>
              <span className="btn btn-outline-white" style={{marginTop:'16px'}}>Get Started →</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
